export default __webpack_public_path__ + "static/media/empty-state-defects.62c21356.svg";